<template>
  <a-card>
    <table-wrapper
      row-key="uuid"
      size="small"
      :border="true"
      :data-source="value||[]"
      :columns="detailColumns"
      :showCheckbox="false"
      :maxHeight="DEFAULTTABLEMAXHEIGHT"
    >
      <template #buttons>
        <export-btn
          :api="'ticket/exportMaterial/' + id"
          :selectedIds="selectedIds"
          :tableColumn="detailColumns"
          method="get"
        >导出清单</export-btn>
      </template>
      <template #count="{ record }">{{ $filters.formatMoneyZero(record.count) }}</template>
      <template #price="{ record }">{{ $filters.formatMoneyZero(record.price) }}</template>
      <template #totalPrice="{ record }">{{
        $filters.formatMoneyZero(record.totalPrice)
      }}</template>

      <template #isInnerContract="{ record, index }">
        <span v-if="record.isInnerContract === true">是</span>
        <span v-if="record.isInnerContract === false">否</span>
      </template>

      <template #footer>
        <div class="flex">
          <div>
            <span>总计：</span>
            <span>{{ $filters.formatMoney(totalPrice) }}元</span>
            <span>（{{ $filters.moneyToChinese(totalPrice) }}）</span>
          </div>
        </div>
      </template>
    </table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { message } from "ant-design-vue";
import { computed, defineComponent, onMounted, reactive, Ref, toRefs, PropType } from "vue";
import { attachUuid, plusTotalPrice } from "@/utils";
import { DEFAULTTABLEMAXHEIGHT } from "@/core/constant";
import { useStore } from "@/store";
import { detailColumns } from "./constant";
interface IState {
  records: any[];
  totalPrice: Ref<number>;
  selectedIds: Ref<Array<any>>;
}

export default defineComponent({
  name: "MaintenanceMaterialDetail",
  // components: { ExportBtn },
  props: {
    id: {
      type: String,
      required: true,
    },

    value: { type: Array as PropType<any[]>, default: [] },
  },
  setup(props) {
    const store = useStore();
    const state = reactive<IState>({
      records: [],
      totalPrice: computed(() => plusTotalPrice(props.value)),
      selectedIds: computed(() => {
        let ids = props.value?.reduce((o, cur) => {
          o.push(cur.id);
          return o;
        }, []);
        return ids;
      }),
    });

    onMounted(async () => {});

    return {
      ...toRefs(state),
      detailColumns,
      DEFAULTTABLEMAXHEIGHT,
    };
  },
});
</script>
